import axios from 'axios';

const service = axios.create({
	withCredentials: true, // 传递cookie
	// timeout        : 10000, // 请求超时时间
});

// axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

// request 拦截器
service.interceptors.request.use(
	config => {
        // 在发送请求之前做些什么
		return config;
	}, error => {
        // 对请求错误做些什么
		Promise.reject(error);
	}
);

// response 拦截器
service.interceptors.response.use(
	response => {
		// 对响应数据做点什么
		return response.data;
	},
	error => {
		// 对响应错误做点什么
        return Promise.reject(error);
	}
);

// 取消拦截器
// service.interceptors.request.eject("");

export default service;